import axiosInstance from "auth/FetchInterceptor";
import {
  REPORT_ORDER_DETAIL_SEARCH,
  REPORT_PRODUCT_PERFORMANCE_SEARCH,
  REPORT_EMPLOYEE_PERFORMANCE_SEARCH,
  REPORT_CUSTOMER_OVERVIEW_SEARCH,
  REPORT_INVOICE_SEARCH,
  REPORT_TREND_SEARCH,
  REPORT_ORDER_RISK_CONTROL_SEARCH,
  REPORT_INVENTORY_LOSS_SEARCH,
  REPORT_INVENTORY_OVERVIEW_SEARCH,
  REPORT_CASHBOOK_DEBT_SEARCH,
  REPORT_PAYMENT_CASH_FLOW_SEARCH,
  REPORT_PROFIT_SEARCH,
  REPORT_SUPPLIER_SEARCH,
  REPORT_PROMOTION_EFFECT_SEARCH,
  REPORT_DETAIL_EXPORT,
  REPORT_INVENTORY_SUMMARY_SEARCH,
  SUPPLIER_FILTER_SEARCH,
  REPORT_ORDER_ITEM_SEARCH,
} from "constants/ApiConstant";

const ReportDetailService = {};

ReportDetailService.getOrderDetail = function (params) {
  return axiosInstance.post(REPORT_ORDER_DETAIL_SEARCH, params);
};

ReportDetailService.getOrderItem = function (params) {
  return axiosInstance.post(REPORT_ORDER_ITEM_SEARCH, params);
};

ReportDetailService.getProductPerformance = function (params) {
  return axiosInstance.post(REPORT_PRODUCT_PERFORMANCE_SEARCH, params);
};

ReportDetailService.getEmployeePerformance = function (params) {
  return axiosInstance.post(REPORT_EMPLOYEE_PERFORMANCE_SEARCH, params);
};

ReportDetailService.getCustomerOverview = function (params) {
  return axiosInstance.post(REPORT_CUSTOMER_OVERVIEW_SEARCH, params);
};

ReportDetailService.getInvoice = function (params) {
  return axiosInstance.post(REPORT_INVOICE_SEARCH, params);
};

ReportDetailService.getTrend = function (params) {
  return axiosInstance.post(REPORT_TREND_SEARCH, params);
};

ReportDetailService.getOrderRiskControl = function (params) {
  return axiosInstance.post(REPORT_ORDER_RISK_CONTROL_SEARCH, params);
};

ReportDetailService.getInventoryLoss = function (params) {
  return axiosInstance.post(REPORT_INVENTORY_LOSS_SEARCH, params);
};

ReportDetailService.getInventoryOverview = function (params) {
  return axiosInstance.post(REPORT_INVENTORY_OVERVIEW_SEARCH, params);
};

ReportDetailService.getCashBookDebt = function (params) {
  return axiosInstance.post(REPORT_CASHBOOK_DEBT_SEARCH, params);
};

ReportDetailService.getPaymentCashFlow = function (params) {
  return axiosInstance.post(REPORT_PAYMENT_CASH_FLOW_SEARCH, params);
};

ReportDetailService.getProfit = function (params) {
  return axiosInstance.post(REPORT_PROFIT_SEARCH, params);
};

ReportDetailService.getSupplier = function (params) {
  return axiosInstance.post(REPORT_SUPPLIER_SEARCH, params);
};

ReportDetailService.getPromotionEffect = function (params) {
  return axiosInstance.post(REPORT_PROMOTION_EFFECT_SEARCH, params);
};

ReportDetailService.exportExcel = function (params) {
  return axiosInstance.post(REPORT_DETAIL_EXPORT, params, {
    responseType: "blob",
  });
};

ReportDetailService.getInventorySummary = function (params) {
  return axiosInstance.post(REPORT_INVENTORY_SUMMARY_SEARCH, params);
};

ReportDetailService.getSupplierFilter = function (params) {
  return axiosInstance.post(SUPPLIER_FILTER_SEARCH, params);
};

export default ReportDetailService;